import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Carousel, Card, Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "../features/product/productSlice";
import "./LandingPage.css";
// import { FontAw esomeIcon } from "@fortawesome/react-fontawesome";
import Footer from "./layouts/Footer";

// import {
//   faFacebookF,
//   faLinkedinIn,
//   faTwitter,
//   faInstagram,
//   faWhatsapp,
// } from "@fortawesome/free-brands-svg-icons";
import Navbar from "./Navbar";

const LandingPage = () => {
  const dispatch = useDispatch();
  const products = useSelector((state) => state.product.data);
  const loading = useSelector((state) => state.product.isLoading);
  const error = useSelector((state) => state.product.isError);
  const [newProducts, setNewProducts] = useState([]);
  const navigate = useNavigate();
  const [remainingProducts, setRemainingProducts] = useState([]);
  const [isCollapsed, setIsCollapsed] = useState(true); // Initially collapsed

  // Function to toggle collapse state
  const toggleMenu = () => {
    setIsCollapsed(!isCollapsed); // Toggle between true and false
  };

  useEffect(() => {
    // Fetch products on component mount
    dispatch(fetchProducts({ page: 1, limit: 4 }));
  }, [dispatch]);

  useEffect(() => {
    if (products.length > 0) {
      // Sort products by 'created_at' or similar field (assuming latest products come first)
      const sortedProducts = [...products].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );

      // Get the first 4 newly added products
      const firstFour = sortedProducts.slice(0, 4);

      // Get the remaining products
      const restProducts = sortedProducts.slice(4);

      // Set the sorted arrays into state
      setNewProducts(firstFour);
      setRemainingProducts(restProducts);
    }
  }, [products]);

  const handleProductClick = (id) => {
    console.log("id:", id);
    navigate(`/productdetail/${id}`); // Navigate to the product details page
  };

  if (loading) {
    return <div>Loading products...</div>;
  }

  if (error) {
    return <div>Error fetching products. Please try again later.</div>;
  }

  // category pe click krne se id uthegi, fir params m pass kr k get kregi product ids jo uss category m h, respectively product by id get krgi, then map function lgake products show kregi
  return (
    <>
      {/* Navbar Section */}
      <Navbar />

      {/* Carousel Section */}
      <section className="carousel-section">
        <Carousel>
          {[
            {
              image: "/assets/images/items/12.jpg",
              caption: "Red cloth Bounded Register",
              description: "Full size register for maintaining records",
            },
            {
              image: "/assets/images/items/10.jpg",
              caption: "Red cloth corner Register",
              description: "Full size register for maintaining records",
            },
          ].map((slide, index) => (
            <Carousel.Item key={index}>
              <img
                className="d-block w-100"
                src={slide.image}
                alt={`Slide ${index + 1}`}
                style={{ maxHeight: "400px", objectFit: "cover" }}
              />
              <Carousel.Caption>
                <h1 style={{ color: "white" }}>{slide.caption}</h1>
                <p>{slide.description}</p>
              </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>
      </section>

      {/* Category Section */}
      <section className="category-section py-4">
        <div className="container">
          <div className="row justify-content-center">
            {[
              {
                name: "Spiral Notebooks",
                imageUrl: "/assets/images/items/16.jpg",
              },
              {
                name: "Peforated Books",
                imageUrl: "/assets/images/items/2.jpg",
              },
              {
                name: "Daybooks",
                imageUrl: "/assets/images/items/3.jpg",
              },
              {
                name: "Hardbound Books",
                imageUrl: "/assets/images/items/4.jpg",
              },
              {
                name: "Speciality Paper",
                imageUrl: "/assets/images/items/5.jpg",
              },
              {
                name: "Registers",
                imageUrl: "/assets/images/items/21.jpg",
              },
              {
                name: "Duplicate Books",
                imageUrl: "/assets/images/items/4.jpg",
              },
              {
                name: "Cash Memo Books",
                imageUrl: "/assets/images/items/28.jpg",
              },
              {
                name: "Red Cloth Copy",
                imageUrl: "/assets/images/items/10.jpg",
              },
            ].map((category, index) => (
              <div className="col-4 col-md-2 text-center" key={index}>
                <div className="category-icon mb-2">
                  <Link to="/categorypage">
                    <img
                      src={category.imageUrl}
                      alt={category.name}
                      className="img-fluid rounded-circle"
                      style={{ width: "80px", height: "80px" }}
                    />
                  </Link>
                </div>
                <p>{category.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Products Section */}

      <section className="featured-products-section">
        <div className="container">
          <h2 className="text-center mb-4">Best Products</h2>
          <Row>
            {[
              {
                name: "Registers",
                imageUrl: "/assets/images/items/21.jpg",
                price: 18,
              },
              {
                name: "Duplicate Books",
                imageUrl: "/assets/images/items/4.jpg",
                price: 14,
              },
              {
                name: "Cash Memo Books",
                imageUrl: "/assets/images/items/28.jpg",
                price: 16,
              },
              {
                name: "Red Cloth Copy",
                imageUrl: "/assets/images/items/10.jpg",
                price: 22,
              },
            ].map((product, index) => (
              <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-4">
                <Card className="h-100">
                  <Card.Img
                    variant="top"
                    src={product.imageUrl || "/assets/images/items/1.jpg"}
                    alt={product.name}
                    style={{ height: "250px", objectFit: "cover" }}
                  />
                  <Card.Body>
                    <Card.Title>{product.name}</Card.Title>
                    <Card.Text>From Rs.{product.price || "N/A"}</Card.Text>
                    <Button
                      variant="outline-danger"
                      className="w-100"
                      onClick={() => handleProductClick(product._id)}
                    >
                      CHOOSE OPTIONS
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      <section>
        <div className="container my-2">
          <h2 className="text-center mb-4">Exclusive Category</h2>
          <div className="row">
            <div className="col-md-4 mb-3">
              <Link to="/categorypage">
                <img
                  src="/assets/images/items/21.jpg"
                  alt="Product 1"
                  className="img-fluid"
                />
              </Link>
            </div>
            <div className="col-md-4 mb-3">
              <Link to="/categorypage">
                <img
                  src="/assets/images/items/16.jpg"
                  alt="Product 2"
                  className="img-fluid"
                />
              </Link>
            </div>
            <div className="col-md-4 mb-3">
              <Link to="/categorypage">
                <img
                  src="/assets/images/items/26.jpg"
                  alt="Product 3"
                  className="img-fluid"
                />
              </Link>
            </div>
            <div className="col-md-4 mb-3">
              <Link to="/categorypage">
                <img
                  src="/assets/images/items/11.jpg"
                  alt="Product 4"
                  className="img-fluid"
                />
              </Link>
            </div>
            <div className="col-md-4 mb-3">
              <Link to="/categorypage">
                <img
                  src="/assets/images/items/9.jpg"
                  alt="Product 5"
                  className="img-fluid"
                />
              </Link>
            </div>
            <div className="col-md-4 mb-3">
              <Link to="/categorypage">
                <img
                  src="/assets/images/items/21.jpg"
                  alt="Product 6"
                  className="img-fluid"
                />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="about-section container-fluid">
          <div class="row align-items-center">
            <div class="col-md-6">
              <img
                src="assets/images/slider/img-slide-1.jpg"
                alt="About Us Image"
                class="img-fluid about-image"
              />
            </div>
            <div class="col-md-6">
              <div class="about-content">
                <h2 style={{ color: "white" }}>About Us</h2>

                <p>
                  <strong>"Natraj"</strong> is a well-known brand of Haryana
                  Traders Pvt. Ltd. which markets paper and plastic stationery
                  products across India and most of the Subcontinent.
                </p>
                <p>
                  Incorporated in 1974 as a partnership firm between the two
                  brothers "NatrajPaperCorporation" is a reliable and well-known
                  enterprise manufacturing paper products for office as well as
                  school needs. 'Fairness' being the basic principle in our
                  dealings and transactions with our customers, we have earned
                  their trust over the past 5 decades. Restructuring the firm in
                  2001 as a sole proprietorship for better operations our wide
                  range of products offers total school and office stationery
                  solutions for corporate houses, educational institutions and
                  other individual customers. Our alliances with several
                  national and international stationery brands provide us with
                  an optimized portfolio that caters to the needs of D2C as well
                  as B2B customers.
                </p>
                <Link to="/about">
                  <button class="btn btn-outline-light">KNOW MORE</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="trust-us-section  container-fluid text-center py-5">
          <h2>Here's why you can trust us</h2>
          <div class="row justify-content-center my-4">
            <div class="col-6 col-md-2">
              <div class="icon-box">
                <img
                  src="/assets/images/items/free_delivery.png"
                  alt="Free Delivery"
                />
              </div>
              <p>Free Delivery Above ₹ 300/-</p>
            </div>
            <div class="col-6 col-md-2">
              <div class="icon-box">
                <img
                  src="/assets/images/items/quality_check.png"
                  alt="Top Quality"
                  class="img-fluid"
                />
              </div>
              <p>Top Quality Products</p>
            </div>
            <div class="col-6 col-md-2">
              <div class="icon-box">
                <img
                  src="/assets/images/items/cash_on_delivery.png"
                  alt="Cash on Delivery"
                  class="img-fluid"
                />
              </div>
              <p>Cash On Delivery Available</p>
            </div>
            <div class="col-6 col-md-2">
              <div class="icon-box">
                <img
                  src="/assets/images/items/secure_payment.png"
                  alt="Secure Payments"
                  class="img-fluid"
                />
              </div>
              <p>100% Secure Payments</p>
            </div>
            <div class="col-6 col-md-2">
              <div class="icon-box">
                <img
                  src="assets/images/items/secure_payment.png"
                  alt="Wide Collection"
                  class="img-fluid"
                />
              </div>
              <p>Wide Collection</p>
            </div>
          </div>
          <button class="btn btn-outline-dark">KNOW MORE</button>
        </div>
      </section>
      <section>
        <h2 class="text-center my-4">Testimonials</h2>
        <div class="testimonials-section container-fluid justify-content-center py-5">
          <div class="row justify-content-center my-4">
            <div class="col-md-3 col-sm-6 text-center testimonial-item">
              <div class="card p-3">
                <img
                  src="assets/images/auth/img-auth-4.jpg"
                  alt="User 1"
                  class="img-fluid rounded"
                />
                <div class="stars my-3">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </div>
                <h5>Widest Range</h5>
                <p>
                  I have been doing my stationery shopping with Natraj
                  Stationery for over a year now. They have the widest range of
                  designs that I could find, and they are always willing to help
                  me figure out the best options.
                </p>
              </div>
            </div>

            <div class="col-md-3 col-sm-6 text-center testimonial-item">
              <div class="card p-3">
                <img
                  src="assets/images/auth/img-auth-3.jpg"
                  alt="User 2"
                  class="img-fluid rounded"
                />
                <div class="stars my-3">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </div>
                <h5>Products look great</h5>
                <p>
                  Natraj Stationery is an amazing store with a wide range of
                  products, from Files to notebooks and more. I find them to
                  have the best prices in town and many great designs.
                </p>
              </div>
            </div>

            <div class="col-md-3 col-sm-6 text-center testimonial-item">
              <div class="card p-3">
                <img
                  src="assets/images/auth/img-auth-2.jpg"
                  alt="User 3"
                  class="img-fluid rounded"
                />
                <div class="stars my-3">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </div>
                <h5>Great Products</h5>
                <p>
                  Stationery is affordable and I get a variety of cute gifts as
                  well. They provide all the informational items related to
                  office, corporate, academics, etc. Their products are of
                  reliable quality.
                </p>
              </div>
            </div>

            <div class="col-md-3 col-sm-6 text-center testimonial-item">
              <div class="card p-3">
                <img
                  src="assets/images/auth/img-auth-1.jpg"
                  alt="User 4"
                  class="img-fluid rounded"
                />
                <div class="stars my-3">
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                  <i class="fas fa-star"></i>
                </div>
                <h5>Premium Quality</h5>
                <p>
                  Absolutely love the range of products they offer. The quality
                  of pages is truly premium and the website is easy to navigate,
                  making the purchasing process seamless.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="featured-in py-5 text-center">
        <h3 className="mb-4">Featured in</h3>
        <div className="d-flex justify-content-center align-items-center">
          <img
            src={"/assets/images/items/social.png"}
            // src={"https://natraj.com/assets/images/items/10.jpg"}
            alt="Amazon"
            className="mx-4"
            style={{ maxHeight: "100px" }}
          />
          {/* <img
            src={"/assets/images/browser/firefox.png"}
            alt="Flipkart"
            className="mx-4"
            style={{ maxHeight: "100px" }}
          /> */}
        </div>
      </section>
      {/* Footer Section */}
      <Footer products={products} />
    </>
  );
};

export default LandingPage;
